import type { LandingProductSlug } from "./landing-product-picker";

const PRODUCT_PATTERNS: ReadonlyArray<{ slug: LandingProductSlug; pattern: RegExp }> = [
  { slug: "plastic-drums", pattern: /\b(plastic|poly|hdpe)\s+drums?\b/i },
  { slug: "metal-drums", pattern: /\b(metal|steel)\s+drums?\b/i },
  { slug: "ibc-totes", pattern: /\b(ibcs?|totes?)\b/i },
  { slug: "gaylord-boxes", pattern: /\bgaylords?\b/i },
  { slug: "wood-crates", pattern: /\bcrates?\b/i },
  { slug: "pallets", pattern: /\bpallets?\b/i },
];

const ZIP_IN_TEXT =
  /\b(\d{5})\b(?!\s*(?:pallets?|gaylords?|totes?|ibcs?|drums?|crates?|boxes|bins?|units?|pcs|pieces|lbs?|pounds|gal(?:lons?)?)\b)/i;

export function productAskedFor(request: string): LandingProductSlug | undefined {
  return PRODUCT_PATTERNS.find(({ pattern }) => pattern.test(request))?.slug;
}

export function zipAskedFor(request: string): string | undefined {
  return ZIP_IN_TEXT.exec(request)?.[1];
}
